import { Avatar } from '@george-labs.com/design-system';
import type { ICON } from '@george-labs.com/george-assets/icons';
import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';

import { t } from '@luna/i18n';

import { BankMessageFlag } from './BankMessagesTypes';

interface IconProps {
    icon: ICON;
    color: COLOR;
    backgroundColor: COLOR;
    label: string;
    dataCy: string;
}

enum BankMessageIconType {
    WARNING,
    ERROR,
    INFO,
}

const getBankMessageIconType = (flags: BankMessageFlag[]): BankMessageIconType => {
    if (flags.includes(BankMessageFlag.MANDATORY) || flags.includes(BankMessageFlag.WARNING)) {
        return BankMessageIconType.WARNING;
    }
    if (flags.includes(BankMessageFlag.ERROR)) {
        return BankMessageIconType.ERROR;
    }

    return BankMessageIconType.INFO;
};

export const getBankMessageIconProps = (flags: BankMessageFlag[] = []): IconProps => {
    const bankMessageIconType = getBankMessageIconType(flags);

    if (bankMessageIconType === BankMessageIconType.WARNING) {
        return {
            icon: Avatar.ICON.WARNING,
            color: Avatar.COLOR.UI_YELLOW,
            backgroundColor: Avatar.COLOR.UI_YELLOW_WEAK,
            label: t('bankMessages.importantMessage'),
            dataCy: 'mandatory-icon',
        };
    }

    if (bankMessageIconType === BankMessageIconType.ERROR) {
        return {
            icon: Avatar.ICON.ERROR_CIRCLE,
            color: Avatar.COLOR.UI_RED,
            backgroundColor: Avatar.COLOR.UI_RED_WEAK,
            label: t('bankMessages.errorMessage'),
            dataCy: 'error-icon',
        };
    }

    return {
        icon: Avatar.ICON.INFO,
        color: Avatar.COLOR.UI_BLUE,
        backgroundColor: Avatar.COLOR.UI_BLUE_WEAK,
        label: t('bankMessages.infoMessage'),
        dataCy: 'info-icon',
    };
};
